
import React from 'react';
import { ExternalLink, TrendingUp, Truck, MapPin, Shield, RotateCcw } from 'lucide-react';
import { PriceDisplay } from '../ui/PriceDisplay';

export function ProductPriceSection({ 
  product, 
  onAmazonClick, 
  onPriceHistoryClick, 
  hasPriceHistory 
}) {
  const { price, price_old, updated_at, stock_status, asin, is_prime } = product;

  const deliveryDate = new Date();
  deliveryDate.setDate(deliveryDate.getDate() + 5);
  const formattedDeliveryDate = deliveryDate.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="space-y-6">
      {/* Price Display */}
      <div className="space-y-2">
        <PriceDisplay
          price={price}
          priceOld={price_old}
          lastUpdated={updated_at}
          stockStatus={stock_status}
          asin={asin}
          size="large"
          showWarning={true}
        />

        {/* Price History Button */}
        {hasPriceHistory && (
          <button
            onClick={onPriceHistoryClick}
            className="text-blue-600 hover:text-blue-800 text-sm underline flex items-center gap-1"
            data-analytics-id="price-history-button"
          >
            <TrendingUp size={14} />
            View Price History
          </button>
        )}

        {/* Delivery Info */}
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-1 mt-4">
          {is_prime ? (
            <>
              <p className="text-gray-900 dark:text-gray-100 flex items-center gap-2">
                <Truck size={16} />
                FREE Prime Delivery
              </p>
              <p>Get it by <span className="font-bold">{formattedDeliveryDate}</span></p>
            </>
          ) : (
            <p className="flex items-center gap-2">
              <Truck size={16} />
              FREE delivery: <span className="font-bold">{formattedDeliveryDate}</span>
            </p>
          )}
          <div className="flex items-center gap-1">
            <MapPin size={14} />
            <span>Deliver to Los Angeles 90022</span>
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-slate-700 p-3 rounded-lg">
        <div className="flex items-center gap-1">
          <Shield size={16} className="text-green-600" />
          <span>Secure Purchase</span>
        </div>
        <div className="flex items-center gap-1">
          <RotateCcw size={16} className="text-blue-600" />
          <span>30-Day Returns</span>
        </div>
      </div>

      {/* Main Amazon CTA */}
      <div className="pt-4">
        <button
  onClick={onAmazonClick}
  className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white px-6 py-3 rounded-full font-medium text-lg transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center gap-2 hover:scale-[1.02]"
  data-analytics-id="main-amazon-cta"
>
  <span>⏳ Grab It Before Price Goes Up!</span>

  <ExternalLink className="w-5 h-5" />
</button>
      </div>
    </div>
  );
}
